<template>
    <div class="checkout-recipient">
        <div v-for="item in recipient.list">
            <component
                :is="item.type"
                :name="getName"
                :checked="item.checked"
                :required="true"
                @change="changeRecipientPerson(item)"
            >
                {{ item.title }}
            </component>

            <div v-if="otherPersonChecked" class="checkout-recipient__footer">
                <component
                    v-for="input in item.inputs"
                    :is="input.type"
                    :name="input.name"
                    :placeholder="input.placeholder"
                    :required="true"
                    @change="({ target }) => setRecipientData(target)"
                />
            </div>
        </div>

        <DefCheckbox
            @change="({ target }) => setCallMeData(target)"
            :value="this.checked ? 'Y' : 'N'"
            :name="recipient.callMe.inputName"
        >
            {{ recipient.callMe.NAME }}
        </DefCheckbox>
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import DefRadio from "../../def/DefRadio/DefRadio";
import DefInput from "../../def/DefInput/DefInput";
import DefPhone from "../../def/DefPhone/DefPhone";
import DefCheckbox from "../../def/DefCheckbox/DefCheckbox";

export default {
    name: 'CheckoutRecipient',
    components: {
        DefRadio,
        DefInput,
        DefPhone,
        DefCheckbox,
    },
    data() {
        return {
            checked: false,
            otherPersonChecked: false,
            recipientRequestData: {},
        }
    },
    computed: {
        ...mapState({
            recipient: ({checkout}) => checkout.data.vue?.recipient,
            orderProps: ({checkout}) => checkout.data?.ORDER_PROP?.properties,
        }),

    },
    methods: {
        ...mapActions({
            setAjax: 'checkout/setAjax',
        }),
        ...mapMutations({
            setRequestData: 'checkout/setRequestData',
        }),
        getName(prop = 'RECIPIENT') {
            return this.orderProps.find(el => el.CODE === prop).inputName;
        },
        getValue(prop = 'RECIPIENT') {
            return this.orderProps.find(el => el.CODE === prop).VALUE;
        },
        changeRecipientPerson(item) {
            this.otherPersonChecked = item.name === 'otherPerson';
            if (!this.otherPersonChecked) this.setRequestData({name: this.getName(), value: this.getValue()});
        },
        setRecipientData(target) {
            this.recipientRequestData[target.name] = target.value;
            let requestData = Object.values(this.recipientRequestData).join(",")

            this.setRequestData({name: this.getName(), value: requestData});
        },
        setCallMeData(target) {
            this.checked = !this.checked;
            this.setRequestData({name: target.name, value: this.checked ? 'Y' : 'N'});
        },
    },

}
</script>

<style lang="scss" scoped>
.checkout-recipient {
    &__footer {
        display: grid;
        grid-gap: 8px;
        @include point-md{
            grid-template-columns: 356px repeat(2, 1fr);
        }
        @include point-lg{
            grid-template-columns: 400px 1fr;
        }
        @include point-xl{
            grid-template-columns: 400px repeat(2, 1fr);
        }
    }
    :deep(.def-radio-component){
        align-items: center;
        margin-bottom: 24px;
    }
    :deep(.def-checkbox-component){
        align-items: center;
    }
    :deep(.def-checkbox-component__text),
    :deep(.def-radio-component__text){
        font-weight: 500;
        font-size: 16px;
        color: #191918;
        transform: translateY(1px);
    }
}
</style>